// extracted by mini-css-extract-plugin
module.exports = {"pointer":"appStatus_pointer__1vehB","search-text":"appStatus_search-text__3Fr_f","app-title":"appStatus_app-title__3Wu5j"};